(function() {
    'use strict';

    angular
        .module('ipmApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                // 500 - internal server error
            	// 400 - bad request
            	if (response.status === 500 ) {
                	$rootScope.$emit('ipmApp.httpError', response);
                }
            }
            return $q.reject(response);
        }
    }
})();
